import { EntityAdapter, createEntityAdapter, EntityState } from "@ngrx/entity";
import { PaginationMetaData } from "../../../api/models/pagination-meta-data.model";

import { DeviceListItem } from "../../../api/models/admin/admin-device.model";

export const devicesAdapter: EntityAdapter<DeviceListItem> =
    createEntityAdapter<DeviceListItem>({
        selectId: (device: DeviceListItem) => device.Id,
    });

export interface DeviceState extends EntityState<DeviceListItem> {
    ids: number[];
    entities: any;
    total: number;
    loaded: boolean;
    devices: DeviceListItem[];
    paginationMetaData: PaginationMetaData;
    searchString: string;
    error:any;
}
